<template>
  <div class="min-h-screen flex flex-col items-center justify-center gap-6 px-4">
    <!-- Branding -->
    <div class="flex flex-col items-center gap-2">
      <img src="/eqsys-white.svg" alt="eqSys" class="h-12 w-auto" />
      <div class="text-sm" style="color:var(--color-muted)">{{ $t('login.subtitle') }}</div>
    </div>

    <div class="max-w-md w-full p-6 shadow-lg z-40 card">
      <h2 class="text-2xl font-semibold mb-2" style="color:var(--color-text)">
        {{ $t('ui.resetPassword') }}
      </h2>
      <p class="text-sm mb-4" style="color:var(--color-muted)">
        {{ $t('ui.enterYourEmailAddressAndWeLlSendYouALinkToResetYourPassword') }}
      </p>

      <!-- Success state -->
      <div v-if="sent" class="space-y-4">
        <div class="rounded p-4 text-sm" style="background:var(--color-surface-2);border:1px solid var(--color-border);color:var(--color-text)">
          {{ $t('ui.ifAnAccountWithThatEmailExistsWeVeSentAResetLinkCheckYourInboxAndSpamFolder') }}
        </div>
        <div class="flex justify-end">
          <router-link to="/login" class="btn">{{ $t('ui.backToSignIn') }}</router-link>
        </div>
      </div>

      <!-- Request form -->
      <form v-else @submit.prevent="onSubmit" class="space-y-4">
        <BaseFormField :label="$t('checkout.email')" :error="error || ''">
          <BaseInput
            ref="emailInput"
            v-model="email"
            type="email"
            autocomplete="email"
            autofocus
            placeholder="deg@eksempel.no"
          />
        </BaseFormField>

        <div class="flex items-center justify-between gap-2">
          <router-link to="/login" class="btn">{{ $t('common.back') }}</router-link>
          <button type="submit" class="btn primary" :disabled="loading || !isEmailValid">
            <span v-if="loading">{{ $t('passwordReset.sending') }}</span>
            <span v-else>{{ $t('passwordReset.send') }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { requestPasswordReset } from '@/api/api.js'
import BaseFormField from '@/components/base/BaseFormField.vue'
import BaseInput from '@/components/base/BaseInput.vue'

const { t } = useI18n()
const route = useRoute()

const email = ref('')
const loading = ref(false)
const error = ref(null)
const sent = ref(false)
const emailInput = ref(null)

const isEmailValid = computed(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()))

onMounted(() => {
  if (route.query?.email) email.value = route.query.email
})

async function onSubmit() {
  if (!isEmailValid.value) return
  loading.value = true
  error.value = null
  try {
    await requestPasswordReset(email.value.trim())
    sent.value = true
  } catch (e) {
    error.value = e.data?.detail || e.data?.error || t('ui.couldNotSendResetLinkPleaseTryAgain')
  } finally {
    loading.value = false
  }
}
</script>
